// extracted by mini-css-extract-plugin
export default {"wrapper":"i2-z","play":"j2-z"};